export default __webpack_public_path__ + "static/media/rehack-15.533b7090.png";